import {
  ProjectStaffStateTypes,
  ProjectStaffActionTypes,
} from "./ProjectStaff.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ProjectStaffStateTypes = {
  fetchAll: resetApiCallState([]),
};

const ProjectStaffReducer = (
  state: ProjectStaffStateTypes = INITIAL_STATE,
  action: any
): ProjectStaffStateTypes => {
  switch (action.type) {
    case ProjectStaffActionTypes.FETCH_ALL_PROJECT_STAFF:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProjectStaffActionTypes.FETCH_ALL_PROJECT_STAFF_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProjectStaffActionTypes.FETCH_ALL_PROJECT_STAFF_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProjectStaffActionTypes.FETCH_ALL_PROJECT_STAFF_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ProjectStaffReducer;
